/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * ProductImageGallery Theme Styles
 *
 * Styles for the product image gallery component including:
 * - Hero image container and Swiper carousel
 * - Image styling and responsive behavior
 * - Skeleton loading states
 */

const ProductImageGallery = {
  parts: [
    'container',
    'heroImageGroup',
    'heroImage',
    'heroImageSkeleton',
    'swiperContainer',
    'swiperSlide',
    'imageWrapper',
    'image'
  ],
  baseStyle: {
    container: {
      // Main container styles
    },
    heroImageGroup: {
      marginBottom: 2,
      position: 'relative',
      width: '100%',
    },
    heroImage: {
      width: '100%',
      position: 'relative',
      // Responsive max-width handled in sizes
    },
    heroImageSkeleton: {
      marginBottom: 2,
      width: '100%',
    },
    swiperContainer: {
      width: '100%',
      height: '100%',
      position: 'relative',
    },
    swiperSlide: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    imageWrapper: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    // Image styles for use in imageProps (CSS properties)
    imageStyle: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  sizes: {
    sm: {
      heroImageSkeleton: {
        maxWidth: ['none', 'none', 'none', '500px'],
      },
      heroImage: {
        maxWidth: ['none', 'none', 'none', '500px'],
      },
    },
    md: {
      heroImageSkeleton: {
        maxWidth: ['none', 'none', 'none', '680px'],
      },
      heroImage: {
        maxWidth: ['none', 'none', 'none', '680px'],
      },
    },
  },
  defaultProps: {
    size: 'md',
  },
};

export default ProductImageGallery;
